import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { WindowRef } from '../../shared/services/window.service';
import { TranslateModule } from '@ngx-translate/core';
import { FundperformanceRoutingModule } from './fundperformance-routing.module'
import { FundperformanceService } from './services/fundperformance.service';
import { ChartConfigService } from './services/chartconfig.service';
import { FundperformanceComponent } from './components/fundperformance.component';
import { MyDatePickerModule } from 'mydatepicker';
import { DpDatePickerModule } from 'ng2-date-picker';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  imports: [
    CommonModule,
    FundperformanceRoutingModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    TooltipModule,
    TranslateModule.forChild(),
    DpDatePickerModule
  ],
  declarations: [FundperformanceComponent],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [FundperformanceService, ChartConfigService, WindowRef]
})
export class FundperformanceModule {
}
